// src/components/store/WeeklyDealsBanner.tsx
"use client";

import { WEEKLY_BANNER_VARIANTS } from "./sections/weekly-banner";

export interface WeeklyBannerData {
  id?: number;
  badge_title?: string;
  title?: string;
  subtitle?: string;
  button_text?: string;
  target_url?: string;
  image?: string | null;
  font_family?: string;
  title_color?: string;
  subtitle_color?: string;
  bg_color?: string;
  gradient_color_1?: string;
  gradient_color_2?: string;
  gradient_color_3?: string;
  gradient_direction?: string;
}

interface WeeklyDealsBannerProps {
  banner?: WeeklyBannerData | null;
  variant?: string;
  subdomain?: string;
}

export default function WeeklyDealsBanner({
  banner,
  variant = "classic_dark",
  subdomain,
}: WeeklyDealsBannerProps) {
  if (!banner) return null;

  // 🌟 এডমিন থেকে সিলেক্ট করা ভ্যারিয়েন্ট অনুযায়ী লোড
  const Component =
    WEEKLY_BANNER_VARIANTS[variant] ||
    WEEKLY_BANNER_VARIANTS["classic_dark"];

  return <Component banner={banner} subdomain={subdomain} />;
}